import { constants, Stack, Text } from '@redbubble/design-system';
import { useIntl } from '@redbubble/next/intl';
import Image from 'next/legacy/image';
import { messages } from '../../messages';
import sizeGuideIcon from './size-guide.svg';

export const Header = () => {
  const intl = useIntl();
  return (
    <Stack
      direction={constants.VERTICAL}
      alignItems="center"
      spacing="xs"
      paddingTop="xxl"
    >
      <Image alt="" src={sizeGuideIcon} width="140" aria-hidden />

      <Text type="display2" element="h2">
        {intl.formatMessage(messages.modalTitle)}
      </Text>
    </Stack>
  );
};
